import React from 'react'
import './whitePanel.css'
import PropTypes from 'prop-types';

export default function whitePanel(
  { 
    title,
    children,
    styleClasses 
  }) {
  return (
    <div className={styleClasses}>
      <div class="title all-caps">
        {title}
      </div>
      {children}
    </div>
  )
}

whitePanel.propTypes = {
  title: PropTypes.string,
  children:PropTypes.string,
  styleClasses:PropTypes.string 
}

whitePanel.defaultProps = {
  title:"",
  children:"",
  styleClasses:"" 
}
